// extracted by mini-css-extract-plugin
export default {"container":"not-found_container__ODEOP","content":"not-found_content__uJJTI","title":"not-found_title__sAai1"};